import React from "react";
import MetaTags from "react-meta-tags";
import { Row } from "reactstrap";

import { Link } from "react-router-dom";

import Banner from "../../components/Common/Banner";
import RegisterInputForm from "../../components/authenticate/RegisterInputForm";
import AuthLayout from "../../components/authenticate/AuthLayout";

const Register = (props) => {

  return (
    <React.Fragment>
      <MetaTags>
        <title>Register | Glogix </title>
      </MetaTags>

      <AuthLayout
        wide
        footer={
          <>
            Already have an account ? <Link to="/login">Login</Link>
          </>
        }
      >
        <div className="gx-auth-card is-split">
          <Row className="g-0 w-100">
            {/* Banner for register  */}
            <Banner />

            {/* Register form  */}
            <RegisterInputForm />
          </Row>
        </div>
      </AuthLayout>
    </React.Fragment>
  );
};

export default Register;
